import { routerReducer } from '@ngrx/router-store';

export const routerFeatureKey = 'router';

export const reducer = routerReducer;
